















































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { isMobile } from '@/utils/validate';
import {
  getInstitutionInfoApi,
  getCountryApi,
  getInstitutionApi,
  getMajorLevelApi
} from '@/api/institution-info';
import infoDetailDrawer from '@/components/Institution-Resource/info-detail.vue';
import SearchGroup from '@/components/Common/SearchGroup.vue';
interface PaginationFilter<T = any> {
  totalResult: number,
  currentPage: number,
  showCount: number,
  totalPage: number
}
@Component({
  name: 'InstitutionInfo',
  components: {
    infoDetailDrawer,
    SearchGroup,
  },
})
export default class extends Vue {
  public loading = false;
  public infoTypeDesc = "";
  public countryId: any = "";
  public institutionId: any = null;
  public majorLevel: any = "";
  public langOptionSelect: any = null;
  public keyword = "";
  public countryOptions: any = [];
  public schoolOptions: any = [];
  public majorLevelOptions: any = [];
  public langOptions: any = [ { id: 1, label: 'Y', labelChn: '是'}, { id: -1, label: 'N', labelChn: '否' }];
  public dataPagination: PaginationFilter<any> = {
    totalResult: 0,
    currentPage: 1,
    showCount: 10,
    totalPage: 1
  };
  public institutionInfoData: any = [];
  public infoDrawer: boolean = false;
  public detailData: any = null;
  public drawerDisplay: string = 'appFee';
  public countryDisable: boolean = true;

  get isMobile() {
    return isMobile();
  }
  get language() {
    return AppModule.language;
  }
  get langEN() {
    if (AppModule.language === 'en-us') {
      return true;
    } else {
      return false;
    }
  }
  public mounted() {
    const { id } = this.$route.params;
    const { infoType } = this.$route.query;

    this.getCountry();
    this.getInstitutionList();
    this.getMajorLevelList();

    if (id && !isNaN(Number(id))) {
      this.countryId = id;
      this.countryDisable = true;
    } else {
      this.countryDisable = false;
    }
    this.searchInstitutionInfo();
  }
  public async getCountry() {
    const { data } = await getCountryApi();
    this.countryOptions = data.datas.filter((v: any) => (v.id !== 34) && (v.id !== 1));
  }
  public async getInstitutionList() {
    const { data } = await getInstitutionApi();
    this.schoolOptions = data.datas;
  }
  public async getMajorLevelList() {
    const { data } = await getMajorLevelApi();
    this.majorLevelOptions = data.datas;
  }
  public async searchInstitutionInfo() {
    this.institutionInfoData = [];
    const params = {
      all: 0,
      currentPage: this.dataPagination.currentPage,
      currentResult: 0,
      data: {
        // effectiveDate: '',
        fkCountryId: this.countryId,
        fkInstitutionId: this.institutionId,
        fkMajorLevelId: this.majorLevel,
        isActive: true,
        keyword: this.keyword,
        isHaveLanguageData: (this.langOptionSelect === 0) || (this.langOptionSelect === null) ?  null : (this.langOptionSelect > 0 ? true : false)
      },
      showCount: this.dataPagination.showCount,
      totalIssueItem: 0,
      totalPage: 1,
      totalResult: 0
    }

    const res = await getInstitutionInfoApi(params);
    if (res.data.code === "1003") {
      const data = res.data.datas;
      let i = 1;
      data.forEach((item: any) => {
        let countryInfo = {targetId: -1, targetName: ''};
        const countryItems = item.courseAppInfoResultMappingVos.filter((v: any) => v.typeKey === 'u_area_country');
        if (countryItems && (countryItems.length > 0)) {
          countryInfo = countryItems[0].courseAppInfoResultVos[0];
        }

        let institutionInfo = {targetId: -1, targetName: ''};
        const institutionItems = item.courseAppInfoResultMappingVos.filter((v: any) => v.typeKey === 'm_institution');
        if (institutionItems && (institutionItems.length > 0)) {
          institutionInfo = institutionItems[0].courseAppInfoResultVos[0];
        }

        let majorLevelInfo = {targetId: -1, targetName: ''};
        const majorLevelItems = item.courseAppInfoResultMappingVos.filter((v: any) => v.typeKey === 'u_major_level');
        if (majorLevelItems && (majorLevelItems.length > 0)) {
          majorLevelInfo = majorLevelItems[0].courseAppInfoResultVos[0];
        }

        let courseInfoTmp: any = [];
        const courseInfo: any = [];
        const courseItems = item.courseAppInfoResultMappingVos.filter((v: any) => v.typeKey === 'm_institution_course');
        if (courseItems && (courseItems.length > 0)) {
          courseInfoTmp = courseItems[0].courseAppInfoResultVos;
          let j = 1;
          courseInfoTmp.forEach((courseItem: any) => {
            courseInfo.push({id: courseItem.id, rank: j, description: courseItem.description});
            j++;
          })
        }

        this.institutionInfoData.push({
          rank: i,
          country: countryInfo.targetName,
          countryChn: countryInfo.targetName,
          institution: institutionInfo.targetName,
          applicationFeeFound: item.isFree,
          applicationFee: item.title,
          applicationFeeDetail: item.description,
          langTypeFound: (item.institutionInfoDtos && (item.institutionInfoDtos.length > 0)) ? true : false,
          langType: (item.institutionInfoDtos && (item.institutionInfoDtos.length > 0)) ? item.institutionInfoDtos : [],
          courseType: item.courseType,
          courseLevel:item.courseLevel,
          majorLevel: majorLevelInfo.targetName,
          course: courseInfo
        });
        i++;
      });
      this.dataPagination = res.data.page;
    }
  }
  public async handleSearch() {
    this.loading = true;
    this.searchInstitutionInfo();
    this.loading = false;
  }
  public async handleReset() {
    //
  }
  public handleCurrentChange(currentPage: number) {
    this.dataPagination.currentPage = currentPage;
    this.handleSearch();
  }
  public handleSizeChange(pageSize: number) {
    this.dataPagination.showCount = pageSize;
    this.handleSearch();
  }
  public viewDetails(item: any, selectTag: string) {
    this.infoDrawer = true;
    this.detailData = item;
    this.drawerDisplay = selectTag;
  }
  public previousInfo() {
    const rank = Number(this.detailData.rank);
    if (rank === 1) {
      return;
    } else {
      const findData = this.institutionInfoData.filter((v: any) => (v.rank === (rank-1)));
      if (findData) {
        this.infoDrawer = true;
        this.detailData = findData[0];
      }
    }
  }
  public nextInfo() {
    const rank = Number(this.detailData.rank);
    if (this.institutionInfoData) {
      if (rank === this.institutionInfoData.length) {
        return;
      } else {
        const findData = this.institutionInfoData.filter((v: any) => (v.rank === (rank+1)));
        if (findData) {
          this.infoDrawer = true;
          this.detailData = findData[0];
        }
      }
    } else {
      return;
    }
  }
  public cancelInfoDrawer() {
    this.infoDrawer = false;
  }
}
